import AttachmentUploadModal from './AttachmentUploadModal';

export default AttachmentUploadModal;
